import React from "react";
import { useConfigurationOptionsContext } from "../../../../../../../app/providers/DoorOptionsProvider";
import { Vector3 } from "three";
import {
  DoorGlassMaterial,
  getFrameScaling,
  getGlassPosition,
} from "../../../../../../../shared/utils/door";
import { defaultDoorWidth } from "shared/utils/doorSceneConstants";

interface GlassProps {
  doorNodes: any;
  materials: DoorGlassMaterial;
  index: number;
  passiveIndex?: number;
}

const GlassPassive: React.FC<GlassProps> = ({
  doorNodes,
  materials,
  index,
}) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationGlass,
  } = useConfigurationOptionsContext();

  const scaling = getFrameScaling(
    getConfigurationWidth(0),
    getConfigurationHeight(0),
  );

  const widthScaleFactorPassive =
    getConfigurationWidth(index) / defaultDoorWidth;

  const position = getGlassPosition(getConfigurationHeight(index));
  const scale = new Vector3(scaling.horizontal.x, scaling.vertical.y + 0.02, 1);

  return (
    <group>
      {getConfigurationGlass() !== "Helder" && (
        <mesh
          geometry={doorNodes["glass_passive"].geometry}
          material={materials[getConfigurationGlass()]}
          position={position}
          scale={scale}
          scale-x={widthScaleFactorPassive}
        />
      )}
    </group>
  );
};

export default GlassPassive;
